
const parammap = new Map([
    ["statusId", "leftmenuid"],
    ["subStatusId", "jobsubstatusid"],
    ["jobId", "id"],
    ["customerId", "id"],
    ["customerGroupId", "id"],
    ["departmentId", "id"],
    ["counterId", "id"],
    ["modelId", "id"],
    ["typeId", "id"],
    ["categoryId", "id"],
    ["machineId", "id"],
    ["documentId", "id"],
    ["supplierId", "id"],
    ["articleId", "id"],
    ["articleNumber", "articlenumber"],
    ["contractTypeId", "typeId"],
    ["contractId", "contractId"],
]);

export default parammap;